import React, { useState } from "react";
import {
  connectedSources,
  eventsSegments,
  metrics,
  profileSegments,
} from "./data";
import { MetricCard } from "../../components/marketing/cdp-dashboard/metrics";
import {
  EventSegment,
  ProfileSegment,
} from "../../components/marketing/cdp-dashboard/segments";
import {
  AiJourneyBuilder,
  ConnectedSource,
  RecentlyCreated,
} from "../../components/marketing/cdp-dashboard/connection";

const CustomerDataPlatform: React.FC = () => {
  const [activeView, setActiveView] = useState<
    "profiles" | "events" | "audiences" | "journeys"
  >("profiles");

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-2">
            <h1 className="text-3xl font-bold text-gray-900">
              Customer Data Platform
            </h1>
            <span className="bg-blue-100 text-blue-800 text-xs font-medium px-3 py-1 rounded-full">
              Beta • AI Assisted
            </span>
          </div>
          <p className="text-gray-600">
            Unify customer data, build audiences, and orchestrate journeys
            across SMS, WhatsApp, Email, RCS and Voice.
          </p>
        </div>

        {/* Metrics Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {metrics.map((metric, index) => (
            <MetricCard
              key={index}
              title={metric.title}
              value={metric.value}
              change={metric.change}
              icon={metric.icon}
              isActive={activeView === metric.type}
              onClick={
                metric.clickable ? () => setActiveView(metric.type) : undefined
              }
              clickable={metric.clickable}
            />
          ))}
        </div>

        {/* Segments Section */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-6">
            {activeView === "profiles" ? "Profile Segments" : "Event Segments"}
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {activeView === "profiles"
              ? profileSegments.map((segment, index) => (
                  <ProfileSegment key={index} {...segment} />
                ))
              : eventsSegments.map((segment, index) => (
                  <EventSegment key={index} {...segment} />
                ))}
          </div>
        </div>

        {/* Bottom Section */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Connected Sources */}
          <div className="lg:col-span-2">
            <h2 className="text-xl font-semibold text-gray-900 mb-6">
              Connected Sources
            </h2>
            <div className="space-y-3">
              {connectedSources.map((source, index) => (
                <ConnectedSource key={index} {...source} />
              ))}
            </div>
          </div>

          {/* Right Column */}
          <div className="lg:col-span-1 space-y-6">
            <AiJourneyBuilder />
            <RecentlyCreated />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDataPlatform;
